import { DocumentNode } from '@apollo/client'
import {
  UpdateWorkSpaceDocument,
  UpdateWorkSpaceMutation,
  UpdateWorkSpaceMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type RefetchQueryDescriptor = {
  query: DocumentNode
  variables?: Record<string, unknown>
}

export const useUpdateWorkSpace = () => {
  const [executeMutation] = useMutation(UpdateWorkSpaceDocument, {
    extractorFn: (data: UpdateWorkSpaceMutation) =>
      data.spaceControlMutations.updateSpacecontrolWorkSpace,
  })

  const updateWorkSpace = async (
    variables: UpdateWorkSpaceMutationVariables,
    options?: { refetchQueries?: RefetchQueryDescriptor[] }
  ) => {
    if (!variables.workAreaId) {
      throw new Error('WorkSpace must have valid workArea and location')
    }

    return executeMutation({
      variables,
      refetchQueries: options?.refetchQueries || [],
      awaitRefetchQueries: !!options?.refetchQueries?.length,
    })
  }

  return {
    updateWorkSpace,
  }
}
